//css
import { ScheduleContainer, TheatersSection, City } from "./styles";
import { TitleSectionsPatern } from "../../App";

//components
import InTheaters from "../../components/InTheaters";

//hooks
import { useLocation } from "react-router-dom";
import { useEffect } from "react";
import Contacts from "../../components/Contacts";
import { useFetchDocuments } from "../../hooks/useFetchDocuments";
import Loading from "../../components/Loading";
import { useFetchDocument } from "../../hooks/useFetchDocument";

const enviroment = process.env.REACT_APP_ENVIROMENT;

const Schedule = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  const { documents, loading, error } = useFetchDocuments(
    enviroment === "prod" ? "teatros" : "teatros-test",
    "1",
  );

  const { document: config } = useFetchDocument(
    enviroment === "prod" ? "config" : "config-test",
    "config",
  );

  return (
    <ScheduleContainer>
      <TheatersSection>
        <TitleSectionsPatern>Em cartaz</TitleSectionsPatern>
        {loading && <Loading />}
        {!loading && (
          <>
            {config &&
              config.cidades &&
              config.cidades.length > 0 &&
              config.cidades
                .filter((c) => c.ativo)
                .map((c, i) => (
                  <>
                    <City>{c.cidade}</City>
                    {documents && !loading && !error && (
                      <>
                        {documents &&
                          documents.filter((doc) => doc.cidade === c.cidade)
                            .length <= 0 && (
                            <h2 style={{ textAlign: "center" }}>Em Breve!</h2>
                          )}
                        {documents &&
                          documents.length > 0 &&
                          documents.filter((doc) => doc.cidade === c.cidade)
                            .length > 0 &&
                          documents
                            .filter((doc) => doc.cidade === c.cidade)
                            .map((peca, i) => (
                              <InTheaters key={i} theater={peca} />
                            ))}
                      </>
                    )}
                  </>
                ))}
          </>
        )}
      </TheatersSection>
      <Contacts subject={"Programação"} />
    </ScheduleContainer>
  );
};

export default Schedule;
